import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import {FormArray, FormGroup} from "@angular/forms";
import {
  BalanceItem, BokkzJrLogic,
  ClientEntity, FormattedExplanation, Jaarrapportage,
  JaarrapportageEntity, Jaarrekening, TrialBalanceItem
} from "@snelstart-ventures/fiscaal/domain-logic";
import {BokkzAlgDataService, BokkzJrDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import { SelectFormControlItem, SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { combineLatest, distinctUntilChanged, Observable, ReplaySubject, Subject, takeUntil } from 'rxjs';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SpecTrialbalanceComponent } from '../spec-trialbalance/spec-trialbalance.component';
import { SpecFormattedexplanationComponent } from '../spec-formattedexplanation/spec-formattedexplanation.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-spec-voorraad',
  templateUrl: './spec-voorraad.component.html',
  imports: [
    SharedUiFormControlsModule,
    SharedUiDetailsModule,
    SharedUiButtonModule,
    SpecTrialbalanceComponent,
    SpecFormattedexplanationComponent,
    CommonModule
  ],
  styleUrls: ['./spec-voorraad.component.css']
})
export class SpecVoorraadComponent implements OnInit,OnChanges,OnDestroy {

  @Input() public id!: string;
  @Input() selectedTabObservable!: Observable<number>;
  private selectedTabSubject = new ReplaySubject<number>(1);
  showCustomControls = true;
  private destroy$ = new Subject<void>();
  public selectedTab = 0;
  public index = 0;
  public dialogVisible = false;
  public client = {} as ClientEntity;
  public jrEntity = {} as JaarrapportageEntity;
  public isRechtspersoon = false;

  public inventoriesFg = {} as FormGroup;
  public inventoryRawMaterialsConsumablesFg = {} as FormGroup;
  public workInProgressFg = {} as FormGroup;
  public inventoryFinishedTradeGoodsFg = {} as FormGroup;
  public prepaymentsInventoriesFg = {} as FormGroup;
  public inventoriesDisclosureFg = {} as FormGroup;
  public inventoryRawMaterialsConsumablesDisclosureFg = {} as FormGroup;
  public workInProgressDisclosureFg = {} as FormGroup;
  public inventoryFinishedTradeGoodsDisclosureFg = {} as FormGroup;
  public prepaymentsInventoriesDisclosureFg = {} as FormGroup;
  public inventoriesInterestCapitalisedDuringPeriodDescriptionFg = {} as FormGroup;
  public inventoriesNoLegalOwnershipDescriptionFg = {} as FormGroup;
  public inventoriesPledgedAsCollateralDescriptionFg = {} as FormGroup;
  public inventoriesPurchaseCommitmentsDescriptionFg = {} as FormGroup;
  public inventoriesCostMethodDescriptionFg = {} as FormGroup;
  public agriculturalInventoriesCurrentValueDisclosureFg = {} as FormGroup;
  public agriculturalInventoriesCurrentValueRevaluationsDisclosureFg = {} as FormGroup;
  public chosenTreatmentRealizedRevaluationsOfAgriculturalStocksDescriptionFg = {} as FormGroup;
  public inventoriesRealisableValueDescriptionFg = {} as FormGroup;
  public inventoriesWriteDownReversalCircumstancesDescriptionFg = {} as FormGroup;

  public optionsJaNee: SelectFormControlItem<boolean>[] = [
    {value: true, label: "Ja"},
    {value: false, label: "Nee"},
  ];

  public showDialog(input: number) {
    this.index = input
    this.dialogVisible = true;
  }

  constructor(
    public algDataService: BokkzAlgDataService,
    private cdRef: ChangeDetectorRef,
    private jrLogicService: BokkzJrLogic,
    public jrDataService: BokkzJrDataService) {
    this.createFormGroups();
  }

  ngOnInit(): void {
    if (this.selectedTabObservable) {
      this.selectedTabObservable
        .pipe(takeUntil(this.destroy$))
        .subscribe(tab => {
          this.selectedTabSubject.next(tab);
        });
    }

    combineLatest([
      this.selectedTabSubject.pipe(distinctUntilChanged()),
      this.jrDataService.jaarrapportageEntity
    ])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([tab, jrEntity]) => {
        this.selectedTab = tab;
        this.jrEntity = jrEntity;
        this.patchData(jrEntity);
      });

    this.jrDataService.isRechtspersoon.subscribe((value) => {
      this.isRechtspersoon = value;
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedTabObservable']) {
      this.selectedTabObservable = changes['selectedTabObservable'].currentValue;
    }
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public createFormGroups() {
    this.inventoriesFg = this.jrDataService.createFormGroupMonetaryNoDecimalsPeriodValues();
    this.inventoryRawMaterialsConsumablesFg = this.jrDataService.createFormGroupBalanceItem();
    this.workInProgressFg = this.jrDataService.createFormGroupBalanceItem();
    this.inventoryFinishedTradeGoodsFg = this.jrDataService.createFormGroupBalanceItem();
    this.prepaymentsInventoriesFg = this.jrDataService.createFormGroupBalanceItem();
    this.inventoriesDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.inventoryRawMaterialsConsumablesDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.workInProgressDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.inventoryFinishedTradeGoodsDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.prepaymentsInventoriesDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.inventoriesInterestCapitalisedDuringPeriodDescriptionFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.inventoriesNoLegalOwnershipDescriptionFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.inventoriesPledgedAsCollateralDescriptionFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.inventoriesPurchaseCommitmentsDescriptionFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.inventoriesCostMethodDescriptionFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.agriculturalInventoriesCurrentValueDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.agriculturalInventoriesCurrentValueRevaluationsDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.chosenTreatmentRealizedRevaluationsOfAgriculturalStocksDescriptionFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.inventoriesRealisableValueDescriptionFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.inventoriesWriteDownReversalCircumstancesDescriptionFg = this.jrDataService.createFormGroupFormattedExplanation();
  }

  private patchData(value: JaarrapportageEntity) {
    const voorraden = value.rapportage?.jaarrekeningen?.at(0)?.balans?.voorraden;

    if (voorraden) {
      this.inventoriesFg.reset()

      if (voorraden.inventories) {
        this.inventoriesFg.patchValue(voorraden.inventories, {emitEvent: false})
      }

      const uitsplitsing = voorraden.voorradenUitsplitsing;
      const tekstueel = voorraden.voorradenTekstueel;

      if (uitsplitsing) {
        if (uitsplitsing.inventoryRawMaterialsConsumables) {
          const subItem = uitsplitsing.inventoryRawMaterialsConsumables;
          this.inventoryRawMaterialsConsumablesFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.inventoryRawMaterialsConsumablesFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.workInProgress) {
          const subItem = uitsplitsing.workInProgress;
          this.workInProgressFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.workInProgressFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.inventoryFinishedTradeGoods) {
          const subItem = uitsplitsing.inventoryFinishedTradeGoods;
          this.inventoryFinishedTradeGoodsFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.inventoryFinishedTradeGoodsFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.prepaymentsInventories) {
          const subItem = uitsplitsing.prepaymentsInventories;
          this.prepaymentsInventoriesFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.prepaymentsInventoriesFg.get('trialBalanceItems') as FormArray)
        }
      }
      if (tekstueel) {
        if (tekstueel.inventoriesDisclosure) {
          this.inventoriesDisclosureFg.patchValue(tekstueel.inventoriesDisclosure);
        }
        if (tekstueel.inventoryRawMaterialsConsumablesDisclosure) {
          this.inventoryRawMaterialsConsumablesDisclosureFg.patchValue(tekstueel.inventoryRawMaterialsConsumablesDisclosure);
        }
        if (tekstueel.workInProgressDisclosure) {
          this.workInProgressDisclosureFg.patchValue(tekstueel.workInProgressDisclosure);
        }
        if (tekstueel.inventoryFinishedTradeGoodsDisclosure) {
          this.inventoryFinishedTradeGoodsDisclosureFg.patchValue(tekstueel.inventoryFinishedTradeGoodsDisclosure);
        }
        if (tekstueel.prepaymentsInventoriesDisclosure) {
          this.prepaymentsInventoriesDisclosureFg.patchValue(tekstueel.prepaymentsInventoriesDisclosure);
        }
        if (tekstueel.inventoriesInterestCapitalisedDuringPeriodDescription) {
          this.inventoriesInterestCapitalisedDuringPeriodDescriptionFg.patchValue(tekstueel.inventoriesInterestCapitalisedDuringPeriodDescription);
        }
        if (tekstueel.inventoriesNoLegalOwnershipDescription) {
          this.inventoriesNoLegalOwnershipDescriptionFg.patchValue(tekstueel.inventoriesNoLegalOwnershipDescription);
        }
        if (tekstueel.inventoriesPledgedAsCollateralDescription) {
          this.inventoriesPledgedAsCollateralDescriptionFg.patchValue(tekstueel.inventoriesPledgedAsCollateralDescription);
        }
        if (tekstueel.inventoriesPurchaseCommitmentsDescription) {
          this.inventoriesPurchaseCommitmentsDescriptionFg.patchValue(tekstueel.inventoriesPurchaseCommitmentsDescription);
        }
        if (tekstueel.inventoriesCostMethodDescription) {
          this.inventoriesCostMethodDescriptionFg.patchValue(tekstueel.inventoriesCostMethodDescription);
        }
        if (tekstueel.agriculturalInventoriesCurrentValueDisclosure) {
          this.agriculturalInventoriesCurrentValueDisclosureFg.patchValue(tekstueel.agriculturalInventoriesCurrentValueDisclosure);
        }
        if (tekstueel.agriculturalInventoriesCurrentValueRevaluationsDisclosure) {
          this.agriculturalInventoriesCurrentValueRevaluationsDisclosureFg.patchValue(tekstueel.agriculturalInventoriesCurrentValueRevaluationsDisclosure);
        }
        if (tekstueel.chosenTreatmentRealizedRevaluationsOfAgriculturalStocksDescription) {
          this.chosenTreatmentRealizedRevaluationsOfAgriculturalStocksDescriptionFg.patchValue(tekstueel.chosenTreatmentRealizedRevaluationsOfAgriculturalStocksDescription);
        }
        if (tekstueel.inventoriesRealisableValueDescription) {
          this.inventoriesRealisableValueDescriptionFg.patchValue(tekstueel.inventoriesRealisableValueDescription);
        }
        if (tekstueel.inventoriesWriteDownReversalCircumstancesDescription) {
          this.inventoriesWriteDownReversalCircumstancesDescriptionFg.patchValue(tekstueel.inventoriesWriteDownReversalCircumstancesDescription);
        }
      }
    }
  }

  updateTrialBalanceItems(lijst?: TrialBalanceItem[], formArray?: FormArray) {
    if (lijst && formArray) {
      for (let i = 0; i < lijst.length; i++) {
        if (i < formArray.length) {
          const control = formArray.at(i) as FormGroup;
          control.patchValue(lijst[i]);
        } else {
          const formGroup = this.jrDataService.createFormGroupTrialBalanceItem(lijst[i])
          formArray.push(formGroup);
        }
      }
    }
  }

  saveForm(): void {
    this.showCustomControls = false;
    this.cdRef.detectChanges();
    setTimeout(() => {
      this.showCustomControls = true;
      this.cdRef.detectChanges();
    });
    this.inventoriesFg.updateValueAndValidity();
    this.inventoryRawMaterialsConsumablesFg.updateValueAndValidity();
    this.workInProgressFg.updateValueAndValidity();
    this.inventoryFinishedTradeGoodsFg.updateValueAndValidity();
    this.prepaymentsInventoriesFg.updateValueAndValidity();

    this.inventoriesDisclosureFg.updateValueAndValidity();
    this.inventoryRawMaterialsConsumablesDisclosureFg.updateValueAndValidity();
    this.workInProgressDisclosureFg.updateValueAndValidity();
    this.inventoryFinishedTradeGoodsDisclosureFg.updateValueAndValidity();
    this.prepaymentsInventoriesDisclosureFg.updateValueAndValidity();
    this.inventoriesInterestCapitalisedDuringPeriodDescriptionFg.updateValueAndValidity();
    this.inventoriesNoLegalOwnershipDescriptionFg.updateValueAndValidity();
    this.inventoriesPledgedAsCollateralDescriptionFg.updateValueAndValidity();
    this.inventoriesPurchaseCommitmentsDescriptionFg.updateValueAndValidity();
    this.inventoriesCostMethodDescriptionFg.updateValueAndValidity();
    this.agriculturalInventoriesCurrentValueDisclosureFg.updateValueAndValidity();
    this.agriculturalInventoriesCurrentValueRevaluationsDisclosureFg.updateValueAndValidity();
    this.chosenTreatmentRealizedRevaluationsOfAgriculturalStocksDescriptionFg.updateValueAndValidity();
    this.inventoriesRealisableValueDescriptionFg.updateValueAndValidity();
    this.inventoriesWriteDownReversalCircumstancesDescriptionFg.updateValueAndValidity();

    if (this.jrEntity && this.jrEntity.rapportage && this.jrEntity.rapportage.jaarrekeningen) {
      this.jrEntity.rapportage.jaarrekeningen[0] = {
        ...this.jrEntity.rapportage.jaarrekeningen[0],
        balans: {
          ...this.jrEntity.rapportage.jaarrekeningen[0].balans,
          voorraden: {
            ...this.jrEntity.rapportage.jaarrekeningen[0].balans?.voorraden,
            voorradenUitsplitsing: {
              ...this.jrEntity.rapportage.jaarrekeningen[0].balans?.voorraden?.voorradenUitsplitsing,
              inventoryRawMaterialsConsumables: this.inventoryRawMaterialsConsumablesFg.value,
              workInProgress: this.workInProgressFg.value,
              inventoryFinishedTradeGoods: this.inventoryFinishedTradeGoodsFg.value,
              prepaymentsInventories: this.prepaymentsInventoriesFg.value,
            },
            voorradenTekstueel: {
              ...this.jrEntity.rapportage.jaarrekeningen[0].balans?.voorraden?.voorradenTekstueel,
              inventoriesDisclosure: this.inventoriesDisclosureFg.value,
              inventoryRawMaterialsConsumablesDisclosure: this.inventoryRawMaterialsConsumablesDisclosureFg.value,
              workInProgressDisclosure: this.workInProgressDisclosureFg.value,
              inventoryFinishedTradeGoodsDisclosure: this.inventoryFinishedTradeGoodsDisclosureFg.value,
              prepaymentsInventoriesDisclosure: this.prepaymentsInventoriesDisclosureFg.value,
              inventoriesInterestCapitalisedDuringPeriodDescription: this.inventoriesInterestCapitalisedDuringPeriodDescriptionFg.value,
              inventoriesNoLegalOwnershipDescription: this.inventoriesNoLegalOwnershipDescriptionFg.value,
              inventoriesPledgedAsCollateralDescription: this.inventoriesPledgedAsCollateralDescriptionFg.value,
              inventoriesPurchaseCommitmentsDescription: this.inventoriesPurchaseCommitmentsDescriptionFg.value,
              inventoriesCostMethodDescription: this.inventoriesCostMethodDescriptionFg.value,
              agriculturalInventoriesCurrentValueDisclosure: this.agriculturalInventoriesCurrentValueDisclosureFg.value,
              agriculturalInventoriesCurrentValueRevaluationsDisclosure: this.agriculturalInventoriesCurrentValueRevaluationsDisclosureFg.value,
              chosenTreatmentRealizedRevaluationsOfAgriculturalStocksDescription: this.chosenTreatmentRealizedRevaluationsOfAgriculturalStocksDescriptionFg.value,
              inventoriesRealisableValueDescription: this.inventoriesRealisableValueDescriptionFg.value,
              inventoriesWriteDownReversalCircumstancesDescription: this.inventoriesWriteDownReversalCircumstancesDescriptionFg.value,
            }
          }
        }
      } as Jaarrekening
    }

    this.jrEntity = {
      ...this.jrEntity,
      rapportage: {
        ...this.jrEntity.rapportage,
        jaarrekeningen: [this.jrEntity.rapportage?.jaarrekeningen?.at(0)]
      }
    } as Jaarrapportage
    this.jrDataService.updateEntity(this.jrEntity);
    this.jrLogicService.getCalculation(this.jrEntity)
  }
}
